/* ============================================================
   CX LAB — RHYTHM JS v2
   File: assets/cxlab-v2.js
   CODEX: Add before </body> in theme.liquid:
     <script src="{{ 'cxlab-v2.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  /* ── 1. Scroll Reveal ── */
  function initReveal() {
    var els = document.querySelectorAll('.cx-reveal');
    if (!els.length || !window.IntersectionObserver) {
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -32px 0px' });

    els.forEach(function(el){ obs.observe(el); });
  }

  /* ── 2. Pastel Stripe: inject CSS var from data-hex ── */
  function initStripes() {
    document.querySelectorAll('[data-hex]').forEach(function(el) {
      var hex = el.getAttribute('data-hex');
      if (hex) el.style.setProperty('--cx-pastel-hex', hex);
    });

    /* Also pull from Shopify metafield data attributes on card wrappers */
    document.querySelectorAll('[data-cx-hex]').forEach(function(el) {
      var hex = el.getAttribute('data-cx-hex');
      if (hex) el.style.setProperty('--cx-pastel-hex', hex);
    });
  }

  /* ── 3. Horizontal Scroll Row — auto-activate on grids >4 items ── */
  function initScrollRows() {
    var grids = document.querySelectorAll('[data-cx-scroll]');
    grids.forEach(function(grid) {
      var selector = '.grid__item, .card-wrapper, .homepage-matrix__item';
      var items = Array.from(grid.querySelectorAll(selector));
      if (items.length > 4) {
        var wrap = document.createElement('div');
        wrap.className = 'cx-scroll-row-wrap';
        var row = document.createElement('div');
        row.className = 'cx-scroll-row';

        grid.parentNode.insertBefore(wrap, grid);
        Array.from(grid.children).forEach(function(child) {
          if (child.matches && child.matches(selector)) {
            row.appendChild(child);
          } else {
            wrap.appendChild(child);
          }
        });
        wrap.appendChild(row);
        grid.parentNode.removeChild(grid);
      }
    });
  }

  /* ── 4. White section text color enforcement ──
     Ensures any dynamically injected text in white/cream sections
     gets correct color without needing per-element classes */
  function initWhiteSections() {
    var whites = document.querySelectorAll('.depth-white, .depth-cream, .cx-editorial');
    whites.forEach(function(sec) {
      sec.querySelectorAll('h1,h2,h3,h4').forEach(function(el) {
        el.style.color = '#000000';
      });
      sec.querySelectorAll('p,li,span:not(.cx-eyebrow)').forEach(function(el) {
        if (!el.closest('.cx-eyebrow')) el.style.color = '#4A4A4A';
      });
    });
  }

  /* ── 4b. Climate Reading Strip ── */
  function initClimateStrip() {
    var strip = document.querySelector('[data-cx-climate-strip]');
    if (!strip) return;

    var tempEl = strip.querySelector('[data-temp]');
    var humEl = strip.querySelector('[data-humidity]');
    var uvEl = strip.querySelector('[data-uv]');
    var tsEl = strip.querySelector('[data-timestamp]');
    var CACHE_KEY = 'cx_climate_dubai_v4';
    var CACHE_TTL = 60 * 60 * 1000;
    var OPEN_METEO_URL = 'https://api.open-meteo.com/v1/forecast?latitude=25.2048&longitude=55.2708&current=temperature_2m,relative_humidity_2m,uv_index&timezone=Asia%2FDubai&forecast_days=1&temperature_unit=celsius';
    var OPEN_METEO_UV_FALLBACK_URL = 'https://api.open-meteo.com/v1/forecast?latitude=25.2048&longitude=55.2708&current=temperature_2m,relative_humidity_2m&daily=uv_index_max&timezone=auto&temperature_unit=celsius';

    function fmtTime(date) {
      return 'as of ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ' GST';
    }

    function hide() {
      strip.hidden = true;
    }

    function show() {
      strip.hidden = false;
    }

    function loadCache() {
      try {
        var raw = sessionStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.fetched || Date.now() - parsed.fetched > CACHE_TTL) return null;
        return parsed;
      } catch (error) {
        return null;
      }
    }

    function saveCache(data) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
      } catch (error) {}
    }

    function readOpenMeteoPayload(payload) {
      var current = payload && payload.current ? payload.current : null;
      if (!current) return null;

      return {
        temp: typeof current.temperature_2m === 'number' ? current.temperature_2m : null,
        humidity: typeof current.relative_humidity_2m === 'number' ? current.relative_humidity_2m : null,
        uv: typeof current.uv_index === 'number' ? current.uv_index : null,
        fetched: Date.now()
      };
    }

    function render(data) {
      if (!data || data.temp == null || data.humidity == null || data.uv == null) {
        hide();
        return;
      }
      show();
      if (tempEl) tempEl.textContent = Math.round(data.temp) + '°C';
      if (humEl) humEl.textContent = Math.round(data.humidity) + '% humidity';
      if (uvEl) uvEl.textContent = 'UV ' + Math.round(data.uv);
      if (tsEl) tsEl.textContent = fmtTime(new Date(data.fetched));
    }

    function fetchOpenMeteoClimate() {
      return fetch(OPEN_METEO_URL, { cache: 'no-store' }).then(function (response) {
        if (!response.ok) {
          throw new Error('Open-Meteo climate strip fetch failed');
        }
        return response.json();
      }).then(function (payload) {
        var data = readOpenMeteoPayload(payload);
        if (!data || data.temp == null || data.humidity == null || data.uv == null) {
          return fetch(OPEN_METEO_UV_FALLBACK_URL, { cache: 'no-store' }).then(function (fallbackResponse) {
            if (!fallbackResponse.ok) {
              throw new Error('Open-Meteo UV fallback fetch failed');
            }
            return fallbackResponse.json();
          }).then(function (fallbackPayload) {
            var fallbackCurrent = fallbackPayload && fallbackPayload.current ? fallbackPayload.current : null;
            var fallbackDaily = fallbackPayload && fallbackPayload.daily ? fallbackPayload.daily : null;
            var fallbackUv = fallbackDaily && Array.isArray(fallbackDaily.uv_index_max) ? fallbackDaily.uv_index_max[0] : null;
            var fallbackData = {
              temp: fallbackCurrent && typeof fallbackCurrent.temperature_2m === 'number' ? fallbackCurrent.temperature_2m : null,
              humidity: fallbackCurrent && typeof fallbackCurrent.relative_humidity_2m === 'number' ? fallbackCurrent.relative_humidity_2m : null,
              uv: typeof fallbackUv === 'number' ? fallbackUv : null,
              fetched: Date.now()
            };
            if (!fallbackData || fallbackData.temp == null || fallbackData.humidity == null || fallbackData.uv == null) {
              hide();
              return;
            }
            render(fallbackData);
            saveCache(fallbackData);
          }).catch(function () {
            hide();
          });
        }
        render(data);
        saveCache(data);
      }).catch(function () {
        hide();
      });
    }

    function boot() {
      var cached = loadCache();
      if (cached) {
        render(cached);
        return;
      }
      fetchOpenMeteoClimate();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  }

  /* ── 4c. PDP Climate Performance radial ── */
  function initClimateRadial() {
    var targets = document.querySelectorAll('[data-cx-radial]');
    if (!targets.length) return;

    var size = 320;
    var center = size / 2;
    var maxRadius = 120;

    function normalize(value) {
      var n = Number(value);
      if (Number.isNaN(n)) return 7;
      if (n < 0) return 0;
      if (n > 10) return 10;
      return n;
    }

    function pointFor(value, axisIndex) {
      var angle = ((Math.PI * 2) / 4) * axisIndex - Math.PI / 2;
      var radius = (value / 10) * maxRadius;
      return [
        center + Math.cos(angle) * radius,
        center + Math.sin(angle) * radius
      ];
    }

    function buildSvg(data) {
      var values = [
        normalize(data.heat),
        normalize(data.humidity),
        normalize(data.ac),
        normalize(data.uv)
      ];

      var points = values.map(function(v, i) {
        var p = pointFor(v, i);
        return p[0].toFixed(2) + ',' + p[1].toFixed(2);
      }).join(' ');

      var svg = '<svg viewBox="0 0 ' + size + ' ' + size + '" width="' + size + '" height="' + size + '" role="img" aria-label="Climate performance: heat ' + values[0] + ', humidity ' + values[1] + ', AC ' + values[2] + ', UV ' + values[3] + ' out of 10">';

      [2.5, 5, 7.5, 10].forEach(function(level) {
        var radius = (level / 10) * maxRadius;
        svg += '<circle cx="' + center + '" cy="' + center + '" r="' + radius.toFixed(2) + '" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="1"/>';
      });

      for (var i = 0; i < 4; i++) {
        var axis = pointFor(10, i);
        svg += '<line x1="' + center + '" y1="' + center + '" x2="' + axis[0].toFixed(2) + '" y2="' + axis[1].toFixed(2) + '" stroke="rgba(255,255,255,0.12)" stroke-width="1"/>';
      }

      svg += '<polygon points="' + points + '" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>';

      values.forEach(function(v, i) {
        var p = pointFor(v, i);
        svg += '<text x="' + p[0].toFixed(2) + '" y="' + (p[1] - 8).toFixed(2) + '" fill="#FFFFFF" font-family="JetBrains Mono, monospace" font-size="10" text-anchor="middle">' + v + '</text>';
      });

      svg += '</svg>';
      return svg;
    }

    targets.forEach(function(el) {
      try {
        var payload = el.getAttribute('data-cx-radial-data') || '{}';
        var data = JSON.parse(payload);
        if (!data || typeof data !== 'object' || data.heat == null || data.humidity == null || data.ac == null || data.uv == null) {
          var emptySection = el.closest('.cx-climate-profile');
          if (emptySection) emptySection.remove();
          return;
        }
        el.innerHTML = buildSvg(data);
      } catch (error) {
        var invalidSection = el.closest('.cx-climate-profile');
        if (invalidSection) invalidSection.remove();
      }
    });
  }

  /* ── 5. Depth class auto-assignment to prevent adjacent duplicates ──
     Runs after DOM ready; adds depth class to unclassed shopify-sections */
  function initDepthCycle() {
    if (!document.body || !document.body.classList.contains('template-index')) {
      return;
    }
    var cycle = ['depth-void', 'depth-halo', 'depth-white', 'depth-substrate', 'depth-cream'];
    var sections = document.querySelectorAll('.shopify-section');
    var idx = 0;
    var prev = null;

    sections.forEach(function(sec) {
      var hasDepth = Array.from(sec.classList).some(function(c){ return c.startsWith('depth-'); });
      if (hasDepth) {
        prev = Array.from(sec.classList).find(function(c){ return c.startsWith('depth-'); });
        return;
      }

      /* Skip if same as previous */
      var candidate = cycle[idx % cycle.length];
      if (candidate === prev) { idx++; candidate = cycle[idx % cycle.length]; }

      sec.classList.add(candidate);
      prev = candidate;
      idx++;
    });
  }

  function scheduleNonCritical(fn) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: 2000 });
      return;
    }

    window.setTimeout(fn, 0);
  }

  function initProductCardRecovery() {
    if (document.body && !document.body.classList.contains('cx-photography-pending')) {
      document.body.classList.add('cx-photography-pending');
    }

    var cards = document.querySelectorAll('.product-card[data-sku], .cxlab-product-card[data-sku]');
    cards.forEach(function(card) {
      var sku = (card.getAttribute('data-sku') || '').trim().toUpperCase();
      var descriptor = card.querySelector('.product-card__descriptor');

      if (descriptor) {
        var raw = String(descriptor.textContent || '').replace(/\s+/g, ' ').trim();
        var normalized = raw.toLowerCase();

        if (sku === 'STL-50' && (normalized === 'ight — light' || normalized === 'ight' || normalized.indexOf('light') !== -1)) {
          descriptor.textContent = 'Light';
        }

        if (sku === 'STB-50' && (normalized === 'warm beige — warm beige' || normalized === 'warm beige')) {
          descriptor.textContent = 'Warm Beige';
        }
      }
    });
  }

  /* ── Run ── */
  function run() {
    initStripes();
    initProductCardRecovery();
    scheduleNonCritical(function () {
      initClimateStrip();
      initClimateRadial();
      initDepthCycle();
      initWhiteSections();
      initReveal();
      initScrollRows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
